<script>
import { useDateFormat } from 'frontend/common/composables/useDateFormat'
import { HumanDateFormatType } from 'frontend/common/date-format/human-date-format-type'

export default {
  name: 'FormattedTime',
  props: {
    t: {
      type: [String, Object],
      validator(value) {
        if (typeof value === 'object') {
          return dayjs.isDayjs(value)
        }
        return true
      },
    },
    tz: { type: String, default: null },
    format: {
      type: String,
      default: 'short',
      validator(value) {
        return Object.values(HumanDateFormatType).includes(value)
      },
    },
    noTooltips: {
      type: Boolean,
      default: false,
    },
    noInBrowserTimezone: {
      type: Boolean,
      default: false,
    },
    showEmpty: {
      type: Boolean,
      default: true,
    },
    showOnlyBrowserTz: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { formatStrings } = useDateFormat()
    return { formatStrings }
  },
  computed: {
    browserTZ() {
      return this.$store.state.session.timeZone
    },
    providedTZ() {
      return this.tz?.length ? this.tz : this.$store.state.session.timeZone
    },
    isDifferentOffset() {
      return this.timeInBrowserTZ.utcOffset() !== this.timeInProvidedTZ.utcOffset()
    },
    timeInBrowserTZ() {
      return dayjs(this.t).tz(this.browserTZ)
    },
    timeInProvidedTZ() {
      return dayjs(this.t).tz(this.providedTZ)
    },
    inBrowserTZTooltipOptions() {
      if (this.noTooltips) return {}
      const formats = this.formatStrings || {}
      return {
        title: `${this.timeInBrowserTZ.format(formats['long'])} in ${this.browserTZ}`,
        placement: 'auto',
      }
    },
    inProvidedTZTooltipOptions() {
      if (this.noTooltips) return {}
      const formats = this.formatStrings || {}
      return {
        title: `${this.timeInProvidedTZ.format(formats['long'])} in ${this.providedTZ}`,
        placement: 'auto',
      }
    },
    formattedTimeInProvidedTZ() {
      const formats = this.formatStrings || {}
      return this.timeInProvidedTZ.format(formats[this.format])
    },
    formattedTimeInBrowserTZ() {
      const formats = this.formatStrings || {}
      return this.timeInBrowserTZ.format(formats['timeOnly'])
    },
  },
}
</script>

<template lang="pug">
template(v-if="t && providedTZ")
  span
    time.in-provided-tz(
      v-if="!showOnlyBrowserTz"
      :datetime="t"
      v-tooltip.options="inProvidedTZTooltipOptions"
    ) {{ formattedTimeInProvidedTZ }}
    time.in-browser-tz(
      v-if="isDifferentOffset && !noInBrowserTimezone"
      :datetime="t"
      v-tooltip.options="inBrowserTZTooltipOptions"
    ) {{ formattedTimeInBrowserTZ }} in {{ browserTZ }}
span.text-black-15(v-else-if="showEmpty && !t") empty
</template>

<style scoped>
.in-browser-tz {
  display: block;
  font-size: 0.75em;
}
</style>
